import {
    OPEN_DROPDOWN,
    CLOSE_DROPDOWN,
} from '../actions'

const initialState = {
    open: false,
    id: undefined
}

const search = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_DROPDOWN: {
            return {
                ...state,
                open: true,
                id: action.payload.id
            }
        }
        case CLOSE_DROPDOWN: {
            if(action.payload.id !== state.id) return state;
            return {
                ...state,
                open: false,
                id: undefined
            }
        }
        default:
            return state
    }
}

export default search



// WEBPACK FOOTER //
// ./src/reducers/dropdown.js